// Contact Us Slider Settings Setup
(function (loader) {
    $('<div id="divContactUsSlider" role="complementary" aria-label="contacus-slider-section"  class="d-none d-md-block"></div>').prependTo("body");
    loader.baseUrls = loader.baseUrls || {};
    if (loader.components === undefined) { loader.components = []; }
    if (loader.componentsData === undefined) { loader.componentsData = []; }
    if (loader.cmsContents === undefined) { loader.cmsContents = []; }
    var url = "https://www.dell.com/support/components";
    if (window.location.origin.indexOf("wip") !== -1) {
        url = window.location.origin + "/support/components";
    }
    loader.baseUrls['contactUsSliderApi'] = url;
    loader.isAuth = false;
    loader.componentsData['contactus-slider'] = window.ContactUsSliderSchema;
})(window.Dell.ComponentLoader = window.Dell.ComponentLoader || {});

// Render contact us slider
(function ($, dell) {

    dell.Components = dell.Components || {};
    dell.Components.ContactUsSlider = dell.Components.ContactUsSlider || {};

    (function () {
        var createAnchorTag;
        var createAccordianUi;
        var compData = {
            featurename: '',
            emcserialnumber: '',
            tagid: ''
        };
        var contactusCmsContent = {
            accountTeamTryagainMsg: '',
            tryAgain: '',
            notificationTryagainMsg: '',
            loading: ''
        };
        var isAccountDataLoaded = false;
        var isNotificationInfoLoaded = false;
        var isEmcUser = false;

        if (Dell.ComponentLoader.componentsData["contactus-slider"] !== '') {
            var tempCompData = Dell.ComponentLoader.componentsData["contactus-slider"];
            if (tempCompData) {
                compData.featurename = (tempCompData.FeatureName !== null && tempCompData.FeatureName !== undefined) ? tempCompData.FeatureName.toLowerCase() : '';
                compData.emcserialnumber = tempCompData.EmcSerialNumber;
                compData.tagid = tempCompData.TagId;
            }
        }

        var loadingimg = `<div class="h-100"><div class="pl-16 py-3 px-2 pt-10 pb-10 d-flex flex-column align-items-center"><span class="mb-1"><object class="dti dti-loading-sm" data="https://www.dellcdn.com/support/staticcdn/core/svg/src/es-loading-sm.svg" type="image/svg+xml"></object></span><span class="text-center">${contactusCmsContent.loading}</span></div></div>`;


        this.createSliderView = (response) => {
            let sliderRow = '', divSlider = '', divIcon = '', divContactSlider = '';
            let emcSliderlg = '';

            if (response === null || response === undefined || response.contactUs === null || response.contactUs === undefined || response.contactUs.length <= 0) {
                this.renderSliderView('');
                return '';
            }

            if (response !== null && response.contactUs.length > 0) {
                var divIconContactus = response.isAPJCountry ? 'contactus-slider-HES-Base-APJCountry' : 'contactus-slider-HES-Base';
                if (response.contactUs.length === 1) {
                    divIcon = `<div style="border-bottom:none;margin-left: 2px;margin-top: -1px;" class="slider-icon"><a class="slider-icon-anchor" href="#"><span class="${divIconContactus} position-relative py-2 px-3" style="margin-top: 7px;${response.isAPJCountry === true ? `margin-left: -4px;` : ``}">${response.contactUsCms.sliderText}</span></a></div>`;
                }
                else if (response.contactUs.length === 2) {
                    divIcon = `<div style="border-bottom:none;margin-left: 2px;margin-top: -1px;" class="slider-icon"><a class="slider-icon-anchor" href="#"><span class="${divIconContactus} position-relative pb-2 px-3" style="margin-top: 11px;${response.isAPJCountry === true ? `margin-left: -4px;` : ``}">${response.contactUsCms.sliderText}</span></a></div>`;
                }
                else {
                    divIcon = `<div style="border-bottom:none;margin-left: 2px;" class="slider-icon"><a class="slider-icon-anchor" href="#"><span class="${divIconContactus} position-relative py-4 px-3" style="margin-top: 35px;${response.isAPJCountry === true ? `margin-left: -4px;` : ``}">${response.contactUsCms.sliderText}</span></a></div>`;
                }
            }

            for (let i = 0, j = response.contactUs.length; i < j; i++) {
                if ((response.contactUs[i].svg != undefined && response.contactUs[i].svg != null) && response.contactUs[i].svg.length > 0) {
                    sliderRow += `${response.contactUs[i].style.toLowerCase() === 'accordian' ? `<div class="accordion contactus-slider-accordion contact-us-accordion" >` : ``} <div class="slider-row">
                                 ${response.contactUs.length - 1 === i ? `<div style="border-bottom:none;" class="slider-icon"><a class="slider-icon-anchor" href="#"><object class="dti dti-xl text-white m-4" data="${response.contactUs[i].svg}" type="image/svg+xml"></object></a></div>`
                            : `<div class="slider-icon"><a class="slider-icon-anchor" href="#"><object class="dti dti-xl text-white m-4" data="${response.contactUs[i].svg}" type="image/svg+xml"></object></a></div>`
                        }<div class="slider-body flex-column align-items-start justify-content-center" style="width: 250px;">${createAnchorTag(response.contactUs[i])}${response.contactUs[i].subLabel !== '' ? `<p class="contact-subtitle">${response.contactUs[i].subLabel}</p>` : ``}</div></div>${createAccordianUi(response.contactUs[i])}${response.contactUs[i].style.toLowerCase() === 'accordian' ? `</div>` : ``}`;
                    divIcon = '';
                }
                else {
                    if (response.contactUsCms != undefined && response.contactUsCms != null && i == 0) {
                        sliderRow += `${response.contactUs[i].style.toLowerCase() === 'accordian' ? `<div class="accordion contactus-slider-accordion contact-us-accordion" >` : ``} <div class="slider-row">
                            <div class="slider-body pt-2 pb-3" style="${j === 1 ? `border-bottom: 1px solid #CD698B` : `border-bottom:none;`}">${createAnchorTag(response.contactUs[i])}${(response.contactUs[i].subLabel !== '' || response.contactUs[i].hesSubLabel !== '') ? `<p class="contact-subtitle">${(response.auth.isEmc === true && response.contactUs[i].hesSubLabel !== '' && response.isHESUser === true) ? response.contactUs[i].hesSubLabel : response.contactUs[i].subLabel}</p>` : ``}</div></div>${createAccordianUi(response.contactUs[i])}${response.contactUs[i].style.toLowerCase() === 'accordian' ? `</div>` : ``}`;
                    }
                    else if (i === j - 1) {
                        sliderRow += `${response.contactUs[i].style.toLowerCase() === 'accordian' ? `<div class="accordion contactus-slider-accordion contact-us-accordion" style="border-bottom:1px solid #CD698B" >` : ``}<div class="slider-row">
                                 <div class="slider-body pt-2 pb-3" style="${response.contactUs[i].style.toLowerCase() === 'accordian' ? `border-bottom:none` : `border-bottom: 1px solid #CD698B`}" id="${response.contactUs[i].id.toLowerCase()}">${createAnchorTag(response.contactUs[i])}${response.contactUs[i].subLabel !== '' ? `<p class="contact-subtitle">${response.contactUs[i].subLabel}</p>` : ``}</div></div>${createAccordianUi(response.contactUs[i], i, j)}${response.contactUs[i].style.toLowerCase() === 'accordian' ? `</div>` : ``}`;
                    }
                    else {
                        sliderRow += `${response.contactUs[i].style.toLowerCase() === 'accordian' ? `<div class="accordion contactus-slider-accordion contact-us-accordion" >` : ``} <div class="slider-row">
                            <div class="slider-body pt-2 pb-3">${createAnchorTag(response.contactUs[i])}${response.contactUs[i].subLabel !== '' ? `<p class="contact-subtitle">${response.contactUs[i].subLabel}</p>` : ``}</div></div>${createAccordianUi(response.contactUs[i])}${response.contactUs[i].style.toLowerCase() === 'accordian' ? `</div>` : ``}`;
                    }
                }
            }

            if (compData.featurename === 'lemcasset' || compData.featurename === 'lemcproduct') {
                emcSliderlg = 'contact-slider-lg';
            }

            divContactSlider = `<div class="d-flex flex-column w-100" style="border-top:1px solid #CD698B;border-bottom:none !important;">${sliderRow}</div>`;
            divSlider = `<div class="contact-slider ${emcSliderlg} d-none d-flex hidden-xs" style="background: white; display: flex !important;">${divIcon + divContactSlider}<div>`;
            this.renderSliderView(divSlider);
            for (let i = 0, j = response.contactUs.length; i < j; i++) {
                if (response.contactUs[i].style.toLowerCase() === 'accordian') {
                    document.getElementById(response.contactUs[i].id).onclick = function () { Dell.Components.ContactUsSlider.getAccordianData(response.contactUs[i].id); };
                }
                else if (response.contactUs[i].style.toLowerCase() === 'staticlink') {
                    document.getElementById(response.contactUs[i].id).onclick = function () { Dell.Components.ContactUsSlider.csCallback(response.contactUs[i].id); };
                }
            }
            $(".slider-icon-anchor").click(function (e) { e.preventDefault(); });
        };

        createAccordianUi = (response) => {
            if (response.style.toLowerCase() === 'accordian') {
                return `<div id="collapse${response.id}" class="collapse js-expanding" data-parent="#divContactUsSlider"><div class="slider-row expandable"><div class="slider-body align-items-start" ${response.id.toLowerCase() === 'accountteam' ? `style="max-height: 150px;"` : ``}><div id="divCs${response.id}">${loadingimg}</div></div></div></div>`;
            }
            else {
                return ``;
            }
        };

        createAnchorTag = (response) => {
            if (response.style.toLowerCase() === 'staticlink') {
                return `<a id="${response.id}" target="_blank" href="${response.link}" data-metrics="{&quot;btnname&quot;:&quot;slidertechsupp&quot;, &quot;appcode&quot;:&quot;${response.prop20}&quot;}" class="js-key-navigable slider-body-title stretched-link">${response.label}</a>`;
            }
            else if (response.style.toLowerCase() === 'accordian') {
                return `<a href="#" id="${response.id}" class="js-key-navigable js-expanding slider-body-title stretched-link collapse-toggle collapsed" data-metrics="{&quot;btnname&quot;:&quot;slidertechsupp&quot;, &quot;appcode&quot;:&quot;${response.prop20}&quot;}"  type="button" data-toggle="collapse" data-target="#collapse${response.id}" aria-expanded="false" aria-controls="collapse${response.id}">${response.label}<object class="dti ml-auto" alt="expand arrow" data="https://www.dellcdn.com/support/staticcdn/contactus-slider/svg/dt-chevron-up.svg" type="image/svg+xml" title="expand" role="none"></object></a>`;

            }
            else {
                return ``;
            }
        };

        this.csCallback = (id) => {
            if (typeof ContactUsSliderCallback !== "undefined") {
                let callBackFun = ContactUsSliderCallback;
                var data = {
                    "id": id
                };
                let returnObj = callBackFun.call(this, data);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.getAccordianData = (id) => {
            if (id.toLowerCase() === 'accountteam') {
                this.getAccountTeamSlider();
            }
            else if (id.toLowerCase() === 'notification') {
                this.getNotification();
            }
        };

        this.renderSliderView = (html) => {
            $("#divContactUsSlider").html(html);
            this.renderSliderUi();
        };

        this.createAccountTeamView = (contacts) => {
            let html = "";
            let urlPath = this.Url();
            let accountsCount = contacts.length;
            let flightpath = `${urlPath.baseUrl}/${urlPath.getImageInfo}`;
            for (var i = 0, j = contacts.length; i < j; i++) {
                html += `<div class="account-member"><div class="member-img"><img id="imgAccountMember1${i}" src="${flightpath}${contacts[i].imageId}" data-pfn="${contacts[i].personFirstName}" data-pln="${contacts[i].personLastName}" alt="${contacts[i].personFirstName} ${contacts[i].personLastName}"></div>
                          <div class="member-details"><p class="name">${contacts[i].personFirstName} ${contacts[i].personLastName}</p><p class="title">${contacts[i].userTitle}</p><a data-metrics="{&quot;btnname&quot;:&quot;slideremail&quot;, &quot;appcode&quot;:&quot;221.950.210.325&quot;}" href="mailto:${contacts[i].emailAddress}" class="js-key-navigable">${contacts[i].emailAddress}</a></div></div>`;
            }
            dellmetricsTrack_prop20_format('222.950.210.330', 'slideracct|' + accountsCount);
            this.renderAccountTeamView(html);
            $("img[id^=imgAccountMember1]").each(function () {
                document.getElementById(this.id).onerror = function () { Dell.Components.ContactUsSlider.AccountTeamImgFallback(this, $(this).attr("data-pfn"), $(this).attr("data-pln")); }
            });
        };

        this.AccountTeamImgFallback = (obj, firstName, lastName) => {
            let imgText = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
            let imgMember = $(obj).parent();
            $(obj).remove();
            imgMember.html(`<p class="m-0">${imgText}</p>`);
        };

        this.createEmptyAccountTeamView = (cmsContent) => {
            let html = `<h6 class="mt-3 mb-3">${cmsContent.supportMessageHeader}</h6><p class="font-type-data mb-4">${cmsContent.supportMessage}</p><div class="mb-3"><a target="_blank" href="${cmsContent.learnMoreLink}">${cmsContent.learnMoreLinkLabel}</a></div>`;
            this.renderAccountTeamView(html);
        };

        var createEmptyAccountTeamViewFun = this.createEmptyAccountTeamView;

        this.renderAccountTeamView = (html) => {
            $("#divCsAccountTeam").html(html);
        };

        this.createErrorAccountTeam = () => {
            let accountTeamTryagainMsgHtml = this.htmlDecode(contactusCmsContent.accountTeamTryagainMsg);
            let html = this.TryAgainView(accountTeamTryagainMsgHtml, contactusCmsContent.tryAgain, 'Dell.Components.ContactUsSlider.TryAgainAccountTeam()', '221.950.210.331');
            this.renderAccountTeamView(html);
            document.getElementById("TryAgainCsText").onclick = function () { Dell.Components.ContactUsSlider.TryAgainAccountTeam(); return false; }
        };

        this.TryAgainAccountTeam = () => {
            this.renderAccountTeamView(loadingimg);
            this.getAccountTeamSlider();
        };

        this.htmlDecode = (value) => {
            return $('<div/>').html(value).text();
        };

        var createErrorAccountTeamFun = this.createErrorAccountTeam;

        this.dellmetricsTrack_prop20_formatOnchange = (event, notificationItem) => {
            var status = event.target.checked === true ? 'on' : 'off';
            if (notificationItem === "eta") {
                dellmetricsTrack_prop20_format('221.950.210.326', 'slidertechadv|<' + status + '>');
            } else if (notificationItem === "esa") {
                dellmetricsTrack_prop20_format('221.950.210.327', 'slidersecadv|<' + status + '>');
            } else if (notificationItem === "productUpdates") {
                dellmetricsTrack_prop20_format('221.950.210.328', 'sliderprdupd|<' + status + '>');
            }
        };

        this.createNotificationView = (response) => {
            let html = `<div class="notification"><p class="mr-1">${response.cmsContent.technicalAdvisory}</p><div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input js-key-navigable inCsUpdateNotification" ${response.emcNotification.eta === false ? "" : "checked"} id="cbCsEtaSwitch"><label class="custom-control-label pl-0" for="cbCsEtaSwitch"><span class="sr-only">${response.cmsContent.technicalAdvisory}</span></label></div></div>
                                        <div class="notification"><p class="mr-1">${response.cmsContent.securityAdvisory}</p><div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input js-key-navigable inCsUpdateNotification" ${response.emcNotification.esa === false ? '' : "checked"} id="cbCsEsaSwitch"><label class="custom-control-label pl-0" for="cbCsEsaSwitch"><span class="sr-only">${response.cmsContent.securityAdvisory}</span></label></div></div>
                                        <div class="notification"><p sclass="mr-1">${response.cmsContent.productUpdates}</p><div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input js-key-navigable inCsUpdateNotification" ${response.emcNotification.productUpdates === false ? '' : "checked"} id="cbCsProductSwitch"><label class="custom-control-label pl-0" for="cbCsProductSwitch"><span class="sr-only">${response.cmsContent.productUpdates}</span></label></div></div>`;
            this.renderNotificationView(html);
            document.getElementById("cbCsEtaSwitch").onchange = function (event) { Dell.Components.ContactUsSlider.dellmetricsTrack_prop20_formatOnchange(event, "eta"); }
            document.getElementById("cbCsEsaSwitch").onchange = function (event) { Dell.Components.ContactUsSlider.dellmetricsTrack_prop20_formatOnchange(event, "esa"); }
            document.getElementById("cbCsProductSwitch").onchange = function (event) { Dell.Components.ContactUsSlider.dellmetricsTrack_prop20_formatOnchange(event, "productUpdates"); }
            this.init();
        };

        this.renderNotificationView = (html) => {
            $("#divCsNotification").html(html);
        };

        this.adjustContactUsBar = () => {
            requestAnimationFrame(function () {
                var contactsSliderElem = document.getElementById("divContactUsSlider");
                if (contactsSliderElem) {
                    $(".contact-slider").attr("style", "top: 180px; display: flex!important;");
                }
            }, 0);
        };

        var adjustContactUsFun = this.adjustContactUsBar;
        var createSliderViewFun = this.createSliderView;
        var createNotificationFun = this.createNotificationView;

        this.createErrorNotification = () => {
            let notificationTryagainMsgHtml = this.htmlDecode(contactusCmsContent.notificationTryagainMsg);
            let tryLoadFun = 'Dell.Components.ContactUsSlider.TryAgainNotificationView()';
            let html = this.TryAgainView(notificationTryagainMsgHtml, contactusCmsContent.tryAgain, tryLoadFun, '221.950.210.330');
            this.renderNotificationView(html);
            document.getElementById("TryAgainCsText").onclick = function () { Dell.Components.ContactUsSlider.TryAgainNotificationView(); return false; }
        };
        var createErrorNotificationView = this.createErrorNotification;

        this.TryAgainView = (htmlStr, tryAgainText, tryLoadFun, tryAgainAnalyticsNo) => {
            htmlStr = htmlStr.replace("</strong>", "</strong><br/>");
            let html = `<div class="alert alert-warning mt-2 mb-2" role="alert"><svg class="dti dti-lg alert-icon"><svg id="es-alert-notice-duotone" viewBox="0 0 32 32"><path fill="currentColor" d="M3.176 25.378c-0.5 0.864 0.123 1.945 1.121 1.945h24.005c0.998 0 1.621-1.081 1.121-1.945l-12.003-20.732c-0.499-0.862-1.743-0.862-2.242 0l-12.003 20.732z"></path><path d="M16.3 10.482c0.715 0 1.295 0.58 1.295 1.295v6.477c0 0.715-0.58 1.295-1.295 1.295s-1.295-0.58-1.295-1.295v-6.477c0-0.715 0.58-1.295 1.295-1.295z"></path><path d="M17.595 23.436c0 0.715-0.58 1.295-1.295 1.295s-1.295-0.58-1.295-1.295c0-0.715 0.58-1.295 1.295-1.295s1.295 0.58 1.295 1.295z"></path></svg></svg>
                        <div class="row"><div class="px-4"><span class="align-self-center">${htmlStr}</span><br /><div class="mt-2"><a data-metrics="{&quot;btnname&quot;:&quot;slideremail&quot;, &quot;appcode&quot;:&quot;${tryAgainAnalyticsNo}&quot;}" id="TryAgainCsText" href="#" class="mt-2">${tryAgainText}</a></div></div></div></div>`;
            return html;
        };

        this.getNotification = () => {
            if (isNotificationInfoLoaded === false) {
                let urlPath = this.Url();
                let url = `${urlPath.baseUrl}/${urlPath.getNotificationInfo}`;
                this.makeAjaxCall(url, "GET")
                    .done(function (response) {
                        isNotificationInfoLoaded = true;
                        createNotificationFun(response);
                        dellmetricsTrack_prop20_format('221.950.210.324', 'slidernotify');
                    }).fail(function () {
                        console.error("Notification Api Failed");
                        createErrorNotificationView();
                        dellmetricsTrack_prop20_format('221.950.210.324', 'slidernotify|unabletofind');
                    });
            }
        };

        this.TryAgainNotificationView = () => {
            this.renderNotificationView(loadingimg);
            this.getNotification();
        };

        var createAccountTeamFun = this.createAccountTeamView;

        this.getAccountTeamSlider = () => {
            if (isAccountDataLoaded === false) {
                let urlPath = this.Url();
                let url = `${urlPath.baseUrl}/${urlPath.getAccountTeamInfo}`;
                this.makeAjaxCall(url, "GET")
                    .done(function (response) {
                        isAccountDataLoaded = true;
                        if (response.emcContacts === null || response.emcContacts === undefined ||
                            response.emcContacts.length <= 0) {
                            createEmptyAccountTeamViewFun(response.cmsContent);
                        }
                        else {
                            createAccountTeamFun(response.emcContacts);
                        }

                    }).fail(function () {
                        createErrorAccountTeamFun();
                        console.error("AccountTeam Api Failed");
                    });
            }

        };

        this.getContactUsSlider = () => {
            let urlPath = this.Url();
            let url = `${urlPath.baseUrl}/${urlPath.getContactUsInfo}`;
            this.makeAjaxCall(url, "GET")
                .done(function (response) {
                    if (response !== undefined && response !== null) {
                        if (Dell.ComponentLoader.cmsContents["contactus-slider"] !== '') {
                            contactusCmsContent = response.contactUsCms;
                        }
                        isEmcUser = response.auth.isEmc;
                        createSliderViewFun(response);
                        adjustContactUsFun();
                    }
                }).fail(function () {
                    console.error('contact us slider api failed');
                });
        };

        this.Url = () => {
            if (Dell.OnlineUtils !== 'undefined' && Dell.OnlineUtils.Lwp !== 'undefined') {
                let baseUrl = 'https://www.dell.com/support/components';
                if (window.location.origin.indexOf("wip") !== -1) {
                    baseUrl = window.location.origin + "/support/components";
                }
                if (Dell.ComponentLoader.baseUrls !== undefined &&
                    Dell.ComponentLoader.baseUrls["contactUsSliderApi"]) {
                    baseUrl = Dell.ComponentLoader.baseUrls["contactUsSliderApi"];
                }

                let featurename = "HomePage";
                if (compData.featurename) {
                    featurename = compData.featurename;
                }
                let urls = {
                    baseUrl: baseUrl,
                    getContactUsInfo: `contactusslider/contactusinfo?featureName=${featurename}&assetId=${compData.emcserialnumber}`,
                    getAccountTeamInfo: `contactusslider/accountteam?productId=${compData.emcserialnumber}`,
                    getImageInfo: `contactusslider/GetImage?imageId=`,
                    getNotificationInfo: `contactusslider/notification?tagId=${compData.tagid}`,
                    updateNotification: `contactusslider/updatenotification`
                };

                return urls;
            }
            return '';
        };

        this.makeAjaxCall = (url, methodType, data) => {
            let ajaxData = {
                url: url,
                method: methodType,
                dataType: "json",
                cache: false,
                contentType: "application/json;",
                async: true
            };

            if (data !== undefined || data !== null) {
                ajaxData.data = data;
            }

            if (url.indexOf("//.dell.com") === -1) {
                ajaxData.xhrFields = {
                    withCredentials: true
                };
            }

            return $.ajax(ajaxData);
        };

        var makeajaxcallfun = this.makeAjaxCall;

        this.init = () => {
            let urlPath = this.Url();
            $(".inCsUpdateNotification").on("click",
                function () {
                    let emcNotification = {
                        TagId: Dell.ComponentLoader.componentsData["contactus-slider"].TagId,
                        Eta: $('#cbCsEtaSwitch').is(":checked"),
                        Esa: $('#cbCsEsaSwitch').is(":checked"),
                        ProductUpdates: $('#cbCsProductSwitch').is(":checked")
                    };
                    let url = `${urlPath.baseUrl}/${urlPath.updateNotification}`;
                    let data = JSON.stringify(emcNotification);
                    makeajaxcallfun(url, "POST", data)
                        .done(function (response) {
                            console.log(response);
                        }).fail(function () {
                            console.error('update notification api failed');
                        });
                });
        };

        this.renderSliderUi = () => {
            // Polyfill for forEach():

            if (window.NodeList && !NodeList.prototype.forEach) {
                NodeList.prototype.forEach = Array.prototype.forEach;
            }

            var contactUsSlider = document.querySelector('.contact-slider');

            var collapsingElements = getCollapsingElements();


            // USED TO ADD EVENTS TO BOOTSTRAP-CLASSED ELEMENTS: 
            var sliderTitleStyle = (elem, event, action) => {
                $(elem).on(event,
                    function (e) {
                        let prevSibling = e.target.previousElementSibling;
                        $(prevSibling).children().each(function () {
                            if (this.classList.contains('slider-body')) {
                                this.classList[action]('slider-title-expanded');
                            }
                        });
                    });
            };

            var collapseAll = () => {
                collapsingElements = getCollapsingElements();
                collapsingElements.forEach(function (elem) {
                    $(elem).collapse('hide');
                });
            };

            var openSlider = () => {
                clearSliderTimeout();
                contactUsSlider.classList.add('open');
            };

            var openSliderClick = () => {
                if ($(".contact-slider").hasClass("open")) {
                    delaySliderClose();
                } else {
                    clearSliderTimeout();
                    contactUsSlider.classList.add('open');
                    dellmetricsTrack_prop20_format('222.950.210.330', 'slidercontactusopen');
                }
                return false;
            };

            var closeSlider = () => {
                collapseAll();
                contactUsSlider.classList.remove('open');
            };

            var sliderTimeout;
            var delaySliderClose = () => {
                sliderTimeout = window.requestAnimationFrame(() => {
                    closeSlider();
                },
                    0);
            };

            var clearSliderTimeout = () => {
                window.clearTimeout(sliderTimeout);
            };

            if (contactUsSlider !== null) {

                $(".slider-icon").each(function () {
                    this.addEventListener('click', () => openSliderClick());
                });

                $(document).click(function (event) {
                    if (!$(event.target).closest(".contact-slider").length) {
                        if ($(event.target).attr("id") !== undefined &&
                            $(event.target).attr("id") === 'TryAgainCsText') {
                            return;
                        }
                        delaySliderClose();
                    }
                });
            }

            // BOOTSTRAP EVENT LISTENERS => Hook into elements that have the Bootstrap .collapse class:
            collapsingElements.forEach((elem) => {
                sliderTitleStyle(elem, 'show.bs.collapse', 'add');
                sliderTitleStyle(elem, 'hidden.bs.collapse', 'remove');
            });

            // RUN THIS ON PAGE LOAD IF YOU WANT THE SLIDER OPEN/CLOSED BY DEFAULT.
            //if (isEmcUser === true) {
            //    requestAnimationFrame(function () {
            //        openSlider();
            //    }, 100);
            //}
        };

        this.getContactUsSlider();

        var getCollapsingElements = () => {
            var collapsingElements = [];
            $(".contactus-slider-accordion").children()
                .each(function () {
                    if (this.classList.contains('js-expanding')) {
                        collapsingElements.push(this);
                    }
                });
            return collapsingElements;
        };

    }).apply(dell.Components.ContactUsSlider);

})(jQuery, Dell = window.Dell || {});